import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'

import { RouteKeys, ROUTES, TmsUserPagePermissions } from '@constants'

import { LinkSpan, StyledNavLink } from '../styles'

const CashFlowNavLinkMessage = <FormattedMessage id="navLink.paid_through" defaultMessage="Pénzmozgások" />

interface CashFlowNavLinksProps {
  blockedByOnboarding: boolean
  hasSubscription: boolean
  lastVisitedSubPage?: string
}

function PureCashFlowNavLinks({ blockedByOnboarding, hasSubscription, lastVisitedSubPage }: CashFlowNavLinksProps) {
  return (
    <StyledNavLink
      blockedByOnboarding={blockedByOnboarding}
      to={lastVisitedSubPage ?? ROUTES.paymentTransactions}
      permission={TmsUserPagePermissions.denyCashflowPermission}
      noSubscription={!hasSubscription}
    >
      <LinkSpan>{CashFlowNavLinkMessage}</LinkSpan>
    </StyledNavLink>
  )
}

export const CashFlowNavLinks = connect((state: Store) => ({
  lastVisitedSubPage: state.controls.lastVisitedSubPage[RouteKeys.CASHFLOW],
}))(PureCashFlowNavLinks)

CashFlowNavLinks.displayName = 'CashFlowNavLinks'
